import { useSearchParams } from 'react-router-dom'

export function useGetToken(): string {
  const [searchParams] = useSearchParams()

  return searchParams.get('token') || ''
}
